// taxes.selectors.ts
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { TaxesState } from './taxes.model';

export const selectTaxesState = createFeatureSelector<TaxesState>('taxes');

export const selectAllTaxes = createSelector(selectTaxesState, (state) => state.taxes);

export const selectIsLoading = createSelector(selectTaxesState, (state) => state.isLoading);

export const selectIsSavingDraft = createSelector(selectTaxesState, (state) => state.isSavingDraft);

export const selectSavingStates = createSelector(selectTaxesState, (state) => state.savingStates);

export const selectDeletingStates = createSelector(selectTaxesState, (state) => state.deletingStates);

export const isSaving = (id: string) => createSelector(selectSavingStates, (savingStates) => !!savingStates[id]);

export const isDeleting = (id: string) =>
  createSelector(selectDeletingStates, (deletingStates) => !!deletingStates[id]);
